// extracted by mini-css-extract-plugin
export var lg = "_redotech-redo-web-lib-arbiter-components-flag-flag-lg";
export var md = "_redotech-redo-web-lib-arbiter-components-flag-flag-md";
export var sm = "_redotech-redo-web-lib-arbiter-components-flag-flag-sm";
export var xs = "_redotech-redo-web-lib-arbiter-components-flag-flag-xs";
export var xxs = "_redotech-redo-web-lib-arbiter-components-flag-flag-xxs";